import store from '@/store';
import request from '@/services/request';
import { ElMessage } from 'element-plus';
export const download = (downloadUrl, filename) => {
  request.get(downloadUrl, {
    responseType: 'blob',
    onDownloadProgress: ProgressEvent => {} // 用来计算下载量（实际项目中可以用来显示下载进度）
  }).then(res => {
    var contentDisposition = res.headers['content-disposition']; // 从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=\"xxxx.docx"\") 设置的文件名;
    var patt = /filename=([^;]+\.[^.;]+)/;
    var result = patt.exec(contentDisposition.replaceAll('"', ''));
    var fileName = filename || result[1]; // 从响应头中取到的fileName 如果本地运行时这里报错,使用跨域浏览器
    let blob = new Blob([res.data]);
    if ('msSaveOrOpenBlob' in navigator) {
      // IE兼容性问题
      window.navigator.msSaveOrOpenBlob(blob, fileName);
      return;
    }
    let downloadUrl = window.URL.createObjectURL(blob); // 创建下载链接
    let link = document.createElement('a'); // 通过点击a标签的方式下载文件到本地
    link.href = downloadUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove(); // 移除a标签
    window.URL.revokeObjectURL(link.href); // 释放资源
  }).catch(err => {
    if (err.response && err.response.data.text) {
      err.response.data.text().then(res => {
        let result = JSON.parse(res);
        if (result.message) {
          ElMessage.error({
            message: result.message
          }, 2000);
        }
      });
    } else {
      ElMessage.error({
        message: store.state.common.lang === 'zh_CN' ? '现在在服务器上找不到此文件。它可能已被删除。' : 'This file can not be found on the server now. It may has been deleted.'
      }, 2000);
    }
  });
};
export default {
  download
};